export const seasonStatusText = (isActive: boolean, differenceDate: number) => {
  if (isActive) {
    return 'ENDS IN: ';
  }

  return differenceDate <= 0 ? 'ENDED: ' : 'STARTS IN: ';
};

export const seasonTitleText = (isActive: boolean, differenceDate: number) => {
  if (isActive) {
    return 'STEAM NEXT FEST';
  }

  return differenceDate <= 0 ? '' : 'ROAD TO SNF';
};
